import { React, useState } from "react";
import { Link } from "react-router-dom";

import { GhostButton } from "../../components/GhostButton";
import { HamburgerContainer, HamburgerLinksContainer, HamburgerMenu, LinksContainer, LogoElem, Nav, StyledLink } from "./styled";

import { AnimatePresence, motion } from "framer-motion";
import { Twirl as Hamburger } from "hamburger-react";

import blackLogo from "../../images/Nav/blackLogo.svg";
import Logo from "../../images/Nav/logo.svg";

import { useLocation } from "react-router-dom";

const NavBar = () => {
  const location = useLocation();

  const [logoPath, setLogoPath] = useState();
  const [backgroundChange, setbackgroundChange] = useState();
  const [colorChange, setColorChange] = useState();

  if (location.pathname === "/") {
    if (logoPath == null || (logoPath === blackLogo && window.scrollY < window.innerHeight + window.innerHeight / 2)) {
      setLogoPath(Logo);
      setbackgroundChange(false);
      setColorChange(false);
    }

    const changeNavbarColor = () => {
      if (window.scrollY >= 1) {
        setbackgroundChange(true);
      } else {
        setbackgroundChange(false);
      }
      if (window.scrollY >= window.innerHeight + window.innerHeight / 2) {
        setColorChange(true);
        setLogoPath(blackLogo);
      } else {
        setColorChange(false);
        setLogoPath(Logo);
      }
    };

    window.addEventListener("scroll", changeNavbarColor);
  } else if (logoPath === Logo || logoPath == null) {
    setLogoPath(blackLogo);
    setbackgroundChange(true);
    setColorChange(true);
  }

  const [hamburgerIsOpen, setHamburgerOpen] = useState(false);

  return (
    <>
      <Nav className={colorChange ? "whiteNavBackground" : "" || backgroundChange ? "darkNavBackground" : ""}>
        <Link to={"/"}>
          <LogoElem src={logoPath} alt="Obrázek loga RPK Technik"></LogoElem>
        </Link>
        <LinksContainer>
          <Link to={"/objednavka-servisu"}>
            <StyledLink>
              <GhostButton type={colorChange} text="Objednávka servisu"></GhostButton>
            </StyledLink>
          </Link>
          <Link to={"/nove-stroje"}>
            <StyledLink>
              <GhostButton type={colorChange} text="Nové stroje"></GhostButton>
            </StyledLink>
          </Link>
          <Link to={"/bazarove-stroje"}>
            <StyledLink>
              <GhostButton type={colorChange} text="Bazarové stroje"></GhostButton>
            </StyledLink>
          </Link>

          <Link to={"/kariera"}>
            <StyledLink>
              <GhostButton type={colorChange} text="Kariéra"></GhostButton>
            </StyledLink>
          </Link>
          <Link to={"/kontakt"}>
            <StyledLink>
              <GhostButton type={colorChange} text="Kontakt"></GhostButton>
            </StyledLink>
          </Link>
        </LinksContainer>

        <HamburgerContainer>
          <Hamburger
            size={20}
            rounded
            toggled={hamburgerIsOpen}
            onToggle={(toggled) => {
              if (toggled) {
                setHamburgerOpen(true);
              } else {
                setHamburgerOpen(false);
              }
            }}
          />
        </HamburgerContainer>
      </Nav>

      <AnimatePresence>
        {hamburgerIsOpen ? (
          <HamburgerMenu as={motion.div} key="box" initial={{ x: "100vh" }} transition={{ duration: 0.5 }} exit={{ x: "100vh", duration: 0.5 }} animate={{ x: "0" }}>
            <HamburgerLinksContainer>
              <Link to={"/objednavka-servisu"} onClick={() => setHamburgerOpen(false)}>
                <StyledLink>
                  <GhostButton type={true} text="Objednávka servisu"></GhostButton>
                </StyledLink>
              </Link>

              <Link to={"/kariera"} onClick={() => setHamburgerOpen(false)}>
                <StyledLink>
                  <GhostButton type={true} text="Kariéra"></GhostButton>
                </StyledLink>
              </Link>

              <Link to={"/nove-stroje"} onClick={() => setHamburgerOpen(false)}>
                <StyledLink>
                  <GhostButton type={true} text="Nové stroje"></GhostButton>
                </StyledLink>
              </Link>

              <Link to={"/bazarove-stroje"} onClick={() => setHamburgerOpen(false)}>
                <StyledLink>
                  <GhostButton type={true} text="Pronájem a prodej"></GhostButton>
                </StyledLink>
              </Link>

              <Link to={"/kontakt"} onClick={() => setHamburgerOpen(false)}>
                <StyledLink>
                  <GhostButton type={true} text="Kontakt"></GhostButton>
                </StyledLink>
              </Link>
            </HamburgerLinksContainer>
          </HamburgerMenu>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default NavBar;
